import * as ng from 'angular';
declare var gtag;
export interface Geolocate {
   ():ng.IPromise<Coordinates>
}

ng.module('selfReg')
   .factory('geolocate', geolocateFactory);

geolocateFactory.$inject = ['$q'];
function geolocateFactory($q:ng.IQService):Geolocate {
   return geolocate;

   function sendEvent(name, value) {
      // submit geolocation result to Google Analytics
      if ('gtag' in window) {
         gtag('event', name, {
            action: value
         });
      }
   }

   function geolocate():ng.IPromise<Coordinates> {
      let deferred = $q.defer<Coordinates>();

      if (!navigator.geolocation) {
         sendEvent('geolocation', 'not_supported');
         deferred.reject('unsupported');
      } else {
         navigator.geolocation.getCurrentPosition(successCallback, errorCallback);
      }

      function successCallback(position:Position) {
         sendEvent('geolocation', 'opt_in');
         deferred.resolve(position.coords);
      }

      function errorCallback(error:PositionError) {
         sendEvent('geolocation', 'opt_out');
         deferred.reject(error);
      }

      return deferred.promise;
   }
}
